export default class LxpNewsFactory {
  constructor() {
    const loadMoreButtons = document.querySelectorAll(
      '.lxp-news-load-more-button',
    );

    loadMoreButtons.forEach((btn) => new LxpNews(btn));

    const copyButtons = document.querySelectorAll('[data-copy-button]');
    copyButtons.forEach((btn) => new LxpNewsCopy(btn));

    const modalToggleButtons = document.querySelectorAll(
      '.news-detail__share-button',
    );
    modalToggleButtons.forEach((btn) => new LxpNewsModalToggle(btn));

    const shareUrlInputs = document.querySelectorAll(
      '.news-detail__share-modal-input',
    );
    shareUrlInputs.forEach((input) => {
      input.value = location.origin + location.pathname;
    });
  }
}

class LxpNews {
  loadMoreButton = null;

  constructor(btn) {
    this.loadMoreButton = btn;

    if ( this.sessionStorage ) {
      customElements.whenDefined('lxp-news-teaser-item').then(() => {  
        for (const news of this.sessionStorage) {
          const newsElement = this.createNewsTeaserElement(news);
          this.parent?.appendChild(newsElement);
        }

        if (this.existingElementsCount >= this.totalNewsCount) {
          btn.remove();
        }
      })
    }

    btn.addEventListener('click', () => this.loadMore(btn));
  }

  get totalNewsCount() {
    return this.parent?.dataset.totalNewsCount ?? 0;
  }

  get existingElementsCount() {
    return this.parent?.querySelectorAll('lxp-news-teaser-item[data-news-id]').length ??
      0;
  }

  get url() {
    return this.loadMoreButton.dataset.url;
  }

  get parent() {
    return document.querySelector(`[data-id="${this.loadMoreButton?.dataset?.appendTo}"]`)?.querySelector('.news-overview__items');
  }

  async loadMore(btn) {
    const appendTo = btn.dataset.appendTo;

    const response = await fetch(this.url, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
 
    if (!response.ok) {
      throw new Error('Failed to fetch news');
    }
    
    const data = await response.json();
  
    const newsOverview = document.querySelector(`[data-id="${appendTo}"]`);
    const sorting = newsOverview?.dataset.sorting ?? 'default';

    if (!this.parent) {
      throw new Error('Parent not found');
    }

    let sortedData = data._items;

    if (sorting === 'newest') {
      sortedData = data._items.toSorted((a, b) =>
        new Date(b.date) > new Date(a.date) ? 1 : -1,
      );
    } else if (sorting === 'oldest') {
      sortedData = data._items.toSorted((a, b) =>
        new Date(a.date) > new Date(b.date) ? 1 : -1,
      );
    }

    const filteredSortedData = sortedData
      .filter((news) => {
        const existingElement = this.parent.querySelector(
          `a[data-news-id="${news.id}"]`,
        );

        return !existingElement;
      })
      .slice(0, 9);

    for (const news of filteredSortedData) {
      const newsElement = this.createNewsTeaserElement(news);
      this.parent.appendChild(newsElement);
      this.saveToStorage(news);
    }

    if (this.existingElementsCount >= sortedData.length) {
      btn.remove();
    }
  }

  createNewsTeaserElement(news) {
    const language = this.loadMoreButton.dataset.language;
    const ctaText = this.loadMoreButton.dataset.ctaText ?? 'Mehr';
    const fallbackImageEvent = this.loadMoreButton.dataset.fallbackImageEvent;
    const fallbackImageWhatsnew = this.loadMoreButton.dataset.fallbackImageWhatsnew;
    const fallbackImageDefault = this.loadMoreButton.dataset.fallbackImageDefault;
    const newstypeLabelPress = this.loadMoreButton.dataset.newstypeLabelPress;
    const newstypeLabelWhatsnew = this.loadMoreButton.dataset.newstypeLabelWhatsnew;

    const newsElement = document.createElement('lxp-news-teaser-item');
    newsElement.setNews(news);

    newsElement.setFallbackImages({
      event: fallbackImageEvent,
      whatsnew: fallbackImageWhatsnew,
      default: fallbackImageDefault,
    });

    newsElement.setNewstypeLabels({
      press: newstypeLabelPress,
      whatsnew: newstypeLabelWhatsnew,
    });

    newsElement.ctaText = ctaText;
    newsElement.language = language;

    return newsElement;
  }

  get storageKey() {
    const key = this.url
      .replace(/[^a-zA-Z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
    return `etka-news-${key}`;
  }

  get sessionStorage() {
    const sessionData = sessionStorage.getItem(this.storageKey);
    return sessionData ? JSON.parse(sessionData) : [];
  }

  saveToStorage(newsJson) {
    const updatedStorageData = this.sessionStorage;
    updatedStorageData.push(newsJson);
    sessionStorage.setItem(this.storageKey, JSON.stringify(updatedStorageData));
  }
}

class LxpNewsCopy {
  constructor(btn) {
    btn.addEventListener('click', () => this.share(btn));
  }

  share(btn) {
    const copyTarget = btn.dataset.copyTarget;
    const input = document.querySelector(`[data-copy-id="${copyTarget}"]`);

    if (!input) {
      throw new Error('Input not found');
    }

    input.focus();
    input.select();

    navigator.clipboard.writeText(input.value);
    btn.classList.add('copied');

    setTimeout(() => {
      btn.classList.remove('copied');
    }, 2000);
  }
}

class LxpNewsModalToggle {
  constructor(btn) {
    btn.addEventListener('click', () => this.toggle(btn));
    document.addEventListener('click', this.hideModal)
  }

  toggle(btn) {
    const modal = btn
      .closest('.news-detail__meta-item')
      .querySelector('.news-detail__share-modal');
    modal.hidden = !modal.hidden;
  }

  hideModal(e) {
    if ( e.target.closest('.news-detail__share-button') || e.target.closest('.news-detail__share-modal') ) {
      return;
    }

    document.querySelector('.news-detail__share-modal')?.setAttribute("hidden", true);
  }
}
